"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageMainSliderLabel = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./HomePageMainSliderLabel.scss");
const HomePageMainSliderLabel = (props) => {
    var _a;
    const { data } = props;
    const classNames = (0, classnames_1.default)('home-page-main-slider-label', (_a = props.classNames) !== null && _a !== void 0 ? _a : '');
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h3", { className: 'home-page-main-slider-label__title' }, data.flightText),
        react_1.default.createElement("p", { className: 'home-page-main-slider-label__price' }, data.priceText)));
};
exports.HomePageMainSliderLabel = HomePageMainSliderLabel;
//# sourceMappingURL=HomePageMainSliderLabel.js.map